export default __webpack_public_path__ + "static/media/path3.30c4510c.svg";